import { useContext } from 'react'
import { TokenContext } from './TokenBalanceProvider'

export function useTokenBalance() {
    const value = useContext(TokenContext)
    return value
}
